export enum DateRange {
    ALL= 0,
    TODAY,
    YESTERDAY,
    RECENT7DAY,
    THISWEEK,
    THISMONTH,
    LASTWEEK,
    LASTMONTH,
    CUSTOM
}

export enum DateRangeForReport {
    RECENT7DAY = 0,
    RECENT1MONTHS,
    RECENT3MONTHS,
    CUSTOM
}

export enum DateRangeForFreeTier {
    TODAY,
    YESTERDAY,
    RECENT7DAY,
    CUSTOM
}

export enum DateRangeForFreeTierReport {
    RECENT7DAY,
    CUSTOM
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/date-range.enum.ts